import { Divider } from '@mui/material';
import { Box } from '@mui/system';

export const TimelineDate = ({ date }: { date: string }) => (
  <div className="w-full flex items-center my-4">
    <Divider className="flex-grow" sx={{ borderColor: '#D2E5F5' }} />
    <Box
      component="span"
      className="text-xs font-semibold px-4 py-1 rounded-md"
      sx={{ backgroundColor: '#D2E5F5' }}
    >
      {date}
    </Box>
    <Divider className="flex-grow" sx={{ borderColor: '#D2E5F5' }} />
  </div>
);
